
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/2021-q1-update",
      function () {
        return require("private-next-pages/blog/2021-q1-update.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/2021-q1-update"])
      });
    }
  